export default "__VITE_ASSET__BzEl9zfF__"